import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';
import {
  ShutterMotorType,
  ShutterMode,
} from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'ShutterActuatorSettings',
})
export default class ShutterActuatorSettings extends DeviceSettingsComponent {
  ShutterMotorType = ShutterMotorType;
  ShutterMode = ShutterMode;

  get settings() {
    return this.defaultSettings.shuttersActuatorSettings;
  }
}
